module.exports = __webpack_public_path__ + "static/media/Avatar2b.59f323b0.png";